// Tiny wrapper around the backend WebSocket (/api/ws) with auto-reconnect
// and a local event bus.

const listeners = new Map();
let socket = null;
let reconnectTimer = null;

function wsUrl() {
    const base = (process.env.REACT_APP_BACKEND_URL || "").trim();
    const url = base ? new URL(base) : new URL(window.location.origin);
    url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
    url.pathname = "/api/ws";
    url.search = "";
    url.hash = "";
    return url.toString();
}

function connect() {
    try {
        socket = new WebSocket(wsUrl());
    } catch (e) {
        scheduleReconnect();
        return;
    }
    socket.onmessage = (evt) => {
        try {
            const { event, data } = JSON.parse(evt.data);
            const set = listeners.get(event);
            if (set) set.forEach((fn) => fn(data));
            const all = listeners.get("*");
            if (all) all.forEach((fn) => fn({ event, data }));
        } catch (e) {
            /* noop */
        }
    };
    socket.onclose = () => scheduleReconnect();
    socket.onerror = () => {
        try {
            socket && socket.close();
        } catch (e) { /* noop */ }
    };
}

function scheduleReconnect() {
    if (reconnectTimer) return;
    reconnectTimer = setTimeout(() => {
        reconnectTimer = null;
        connect();
    }, 2000);
}

export function ensureConnected() {
    if (!socket || socket.readyState === WebSocket.CLOSED) connect();
}

export function on(event, fn) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(fn);
    ensureConnected();
    return () => {
        const s = listeners.get(event);
        if (s) s.delete(fn);
    };
}
